import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import SafeIcon from '../../common/SafeIcon';
import { FiMail, FiArrowLeft, FiCheckCircle } from 'react-icons/fi';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [error, setError] = useState('');
  const { resetPassword } = useAppContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    setError('');

    const result = await resetPassword(email);
    if (result.success) {
      setStatus('success');
    } else {
      setStatus('error');
      setError(result.error);
    }
  };

  return (
    <div className="flex-1 bg-stone-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <Link to="/employer/login" className="inline-flex items-center text-sm text-stone-500 hover:text-emerald-600 mb-6 transition-colors">
          <SafeIcon icon={FiArrowLeft} className="mr-2" /> Back to login
        </Link>
        <h2 className="text-3xl font-extrabold text-stone-900">Reset Password</h2>
        <p className="mt-2 text-sm text-stone-600">
          Enter your email and we'll send you a link to reset your password.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-stone-200 text-center">
          {status === 'success' ? (
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="bg-emerald-100 p-3 rounded-full">
                  <SafeIcon icon={FiCheckCircle} className="text-3xl text-emerald-600" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-stone-900">Check your email</h3>
              <p className="text-stone-600">
                We've sent a password reset link to <span className="font-semibold">{email}</span>.
              </p>
              <div className="pt-4">
                <Link
                  to="/employer/login"
                  className="w-full flex justify-center py-2.5 px-4 border border-stone-300 rounded-md shadow-sm text-sm font-medium text-stone-700 bg-white hover:bg-stone-50 transition-colors"
                >
                  Return to login
                </Link>
              </div>
            </div>
          ) : (
            <form className="space-y-6" onSubmit={handleSubmit}>
              {status === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-600 text-sm p-3 rounded-md text-left">
                  {error}
                </div>
              )}
              <div className="text-left">
                <label className="block text-sm font-medium text-stone-700">Email address</label>
                <div className="mt-1">
                  <input
                    type="email"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-stone-300 rounded-md shadow-sm placeholder-stone-400 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="w-full flex justify-center items-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-colors disabled:bg-stone-400"
                >
                  {status === 'loading' ? 'Sending link...' : 'Send reset link'}
                  {status !== 'loading' && <SafeIcon icon={FiMail} className="ml-2" />}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;